/* Banky x MagSafe op de home, ronde 4 (Geert 06-10-2026; sections/banky-magsafe-spotlight.liquid, opmaak en beweging in
   assets/banky-home-magsafe.css). Alleen geladen door die sectie (defer). De intro speelt één keer zodra 30% van de tekening
   in beeld is; buiten beeld staat alles stil (.is-uit). Geen intro bij prefers-reduced-motion, zonder IntersectionObserver
   of als de tekening bij het laden al in beeld staat (dan blijft de eindstand, zonder flits). .is-ga start de kanteling van
   de telefoon pas als de derde tel begint (zie de CSS: zo blijft het b-logo een scherpe vector). Alleen klassen, geen maten. */
(() => {
  const secties = document.querySelectorAll('[data-banky-mk]:not([data-banky-mk-klaar])');
  if (!secties.length) return;
  const stil = !('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  let start = null, zicht = null;
  if (!stil) {
    start = new IntersectionObserver(items => items.forEach(item => {
      if (!item.isIntersecting) return;
      start.unobserve(item.target);
      const sectie = item.target.closest('[data-banky-mk]');
      if (sectie) sectie.classList.add('is-in');
    }), {threshold: 0.3});
    zicht = new IntersectionObserver(items => items.forEach(item => item.target.classList.toggle('is-uit', !item.isIntersecting)));
  }
  secties.forEach(sectie => {
    sectie.setAttribute('data-banky-mk-klaar', '');
    const tekening = sectie.querySelector('.banky-mk__stage');
    if (stil || !tekening) return;
    const r = tekening.getBoundingClientRect();
    if (r.bottom > 0 && r.top < window.innerHeight) return;
    sectie.classList.add('is-motion');
    // De kanteling van de telefoon pas als de derde tel begint (lege animatie bmk-ga op de tekening, zie de CSS).
    sectie.addEventListener('animationend', e => { if (e.animationName === 'bmk-ga') sectie.classList.add('is-ga'); });
    start.observe(tekening);
    zicht.observe(sectie);
  });
})();
